<template>
  <!--  VISTA LISTAR-->
  <template v-if="view === 'listar' ">
    <div class="flex flex-wrap justify-center gap-y-3 md:gap-0 sm:justify-between w-full px-4 py-2 items-center">
      <div class="text-xl font-bold w-full sm:w-auto text-center">
        {{ title }}
      </div>
      <div class="flex flex-wrap gap-3 w-full sm:w-auto">
        <component :is="childHeaderComponent" :mainListCollectionData="mainListCollectionData" :auth-token="authToken">
        </component>
      </div>
    </div>
    
    <FilterRefactComponent :auth-token="authToken" :list-api="listApi" :table-columns="tableColumns" :queries="queries"
      @updateValues="setupUpdateValues"></FilterRefactComponent>
    <TableComponent :entity="entity" :selected-data="selectedReserva" :table-columns="tableColumns"
      :collection-data="collectionReservas" :auth-token="authToken" :list-api="listApi"
      :custom-update-collection-data="customUpdateCollectionData" @updateValues="setupUpdateValues" :customUpdateHidden="(data) => data.estado_cargue != 4"></TableComponent>
    <PaginateRefactComponent :auth-token="authToken" :list-api="listApi" :paginate="paginate" :optionalParams="queries"
      @updateValues="setupUpdateValues"></PaginateRefactComponent>
  </template>
  <!--    VISTA CREAR - ACTUALIZAR-->
  <template v-else>
    <component :is="childFormComponent" :load-data="loadDataReserva" :selected-data="selectedReserva"
        @updateValues="(res) => {setupUpdateValues(res); mainListCollectionData()}" :collectionData="collectionReservas"></component>
  </template>
</template>

<script>
import { reactive, ref } from "vue";
import { useAuth } from "@/components/auth/store/composables";
import ChildHeaderComponent from "@/components/reservas/components/ReservasChildHeaderComponent";
import TableComponent from "@/layouts/main/TableComponent";
import FilterRefactComponent from "@/layouts/FilterRefactComponent";
import PaginateRefactComponent from "@/layouts/PaginateRefactComponent";
import ReservasCrearActualizarComponent from "@/components/reservas/components/ReservasCrearActualizarComponent";
import { useLayoutMain } from "@/layouts/main";
import { copiaProfunda } from "@/common/constants";
import CreateUpdateReservasComponent from "./components/CreateUpdateReservasComponent";

export default {
  name: 'ReservasPresupuestales',
  components: {
    FilterRefactComponent,
    TableComponent,
    PaginateRefactComponent,
    CreateUpdateReservasComponent,
    ChildHeaderComponent,
    ReservasCrearActualizarComponent
  },
  data: function () {
    return {
      Object: Object,
      title: 'Cargues SIAFF',
      entity: { gender: 'm', value: 'Pasivo Exigible' },
      childHeaderComponent: 'childHeaderComponent',
      childFormComponent: 'reservasCrearActualizarComponent',
      tableColumns: {
        'nombre_cargue': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Nombre de la reserva'
        },
        'created_at': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Fecha de creación'
        },
        'estado': {
          isFilter: false,
          isOrder: false,
          isVisibleInTable: false,
          value: 'Estado'
        }
      }
    }
  },
  async setup() {
    const authStored = useAuth();
    const view = ref('listar');
    const collectionReservas = ref([]);
    const authToken = ref(authStored.authToken);
    const selectedReserva = ref({
      id: '',
      nombre_cargue: '',
      estado: '',
      estado_cargue: ''
    });
    const loadDataReserva = ref({
      nombre_cargue: '',
      estado_cargue: '',
    });
    const listApi = reactive({
      create: process.env.VUE_APP_NEST_PASIVOEXIGIBLETEMP_CREATE,
      list: process.env.VUE_APP_NEST_CARGUESIAFF_FINDALL,
      updateState: process.env.VUE_APP_NEST_CARGUESIAFF_UPDATESTATE
    });
    /**
     * Función que se encarga de actualizar los datos de la colección de reservas.
     * @function
     * @returns {Array} - Array con los datos actualizados de la colección de reservas.
     */
    const customUpdateCollectionData = () => {
      const copyCollectionData = copiaProfunda(collectionReservas.value);
      for (const copyData of copyCollectionData) {
        copyData['created_at'] = copyData['created_at'].split('T')[0];
      }
      return copyCollectionData;
    };

    const customUpdateLoadData = () => {
      loadDataReserva.value.usuario_id = JSON.parse(localStorage.getItem("user")).id;
    };

    /**
     * Función asíncrona que se encarga de obtener la lista de usuarios.
     * @function
     * @async
     * @returns {Array} - Array con los datos de la lista de usuarios.
     */
    const {
      paginate,
      queries,
      setupUpdateValues,
      cleanLoadSelectedData,
      mainListCollectionData
    } = await useLayoutMain(view, collectionReservas, authToken, selectedReserva, loadDataReserva, listApi);
    return {
      view,
      collectionReservas,
      authToken,
      selectedReserva,
      loadDataReserva,
      listApi,
      paginate,
      queries,
      setupUpdateValues,
      cleanLoadSelectedData,
      mainListCollectionData,
      customUpdateCollectionData,
      customUpdateLoadData,
      console : console
    };
  }
};
</script>
